<template>
  <div
    style="width:100%;height:100%"
    class="chart-class"
    ref="rongyu"
  ></div>
</template>

<script>
export default {
  props: {
    researchList: "",
  },
  data() {
    return {};
  },
  created(){
    this.researchList.forEach(item=>{
      item.value=item.thesisNum;
    })
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      let dashedPic =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM8AAAAOBAMAAAB6G1V9AAAAD1BMVEX////Kysrk5OTj4+TJycoJ0iFPAAAAG0lEQVQ4y2MYBaNgGAMTQQVFOiABhlEwCugOAMqzCykGOeENAAAAAElFTkSuQmCC";
      let color = ["#36CB8C", "#597EF7", "#FFD900", "#FF7250", "#B34FFF"];
      let chartData = this.researchList;
      let arrName = [];
      let arrValue = [];
      let sum = 0;
      let pieSeries = [],
        lineYAxis = [];

      // 数据处理
      chartData.forEach((v, i) => {
        arrName.push(v.name);
        arrValue.push(v.value);
        sum = sum + v.value;
      });

      // 图表option整理
      chartData.forEach((v, i) => {
        pieSeries.push({
          name: "研修成果情况",
          type: "pie",
          clockWise: false,
          hoverAnimation: false,
          radius: [75 - i * 15 + "%", 67 - i * 15 + "%"],
          center: ["40%", "50%"],
          label: {
            show: false,
          },
          data: [
            {
              value: v.value,
              name: v.name,
            },
            {
              value: sum - v.value,
              name: "",
              itemStyle: {
                color: "rgba(0,0,0,0)",
              },
            },
          ],
        });
        pieSeries.push({
          name: "",
          type: "pie",
          silent: true,
          z: 1,
          clockWise: false, //顺时加载
          hoverAnimation: false, //鼠标移入变大
          radius: [75 - i * 15 + "%", 67 - i * 15 + "%"],
          center: ["40%", "50%"],
          label: {
            show: false,
          },
          data: [
            {
              value: 7.5,
              itemStyle: {
                color: "#E3F0FF",
              },
            },
            {
              value: 2.5,
              name: "",
              itemStyle: {
                color: "rgba(0,0,0,0)",
              },
            },
          ],
        });
        v.percent = ((v.value / (sum ? sum : 1)) * 100).toFixed(1) + "%";
        lineYAxis.push({
          value: i,
          textStyle: {
            rich: {
              circle: {
                color: color[i],
                padding: [0, 5],
              },
            },
          },
        });
      });

      let option = {
        backgroundColor: "#fff",
        color: color,
        grid: {
          top: this.researchList.length > 1 ? "10%" : "15%",
          bottom: this.researchList.length > 1 ? "52%" : "18%",
          left: this.researchList.length > 1 ? "38%" : "15%",
          containLabel: false,
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: function (params) {
                let item = chartData[params];
                // console.log(item);
                return (
                  "{line|}{circle|●}{name|" +
                  item.name +
                  "}{bd||}{percent|" +
                  item.percent +
                  "}{value|" +
                  item.value +
                  "}{unit|" +
                  item.unit +
                  "}"
                );
              },
              interval: 0,
              inside: true,
              textStyle: {
                color: "#333",
                fontSize: 14,
                rich: {
                  line: {
                    width: 70,
                    height: 10,
                    backgroundColor: { image: dashedPic },
                  },
                  name: {
                    color: "#666",
                    fontSize: 14,
                  },
                  bd: {
                    color: "#ccc",
                    padding: [0, 5],
                    fontSize: 14,
                  },
                  percent: {
                    color: "#333",
                    fontSize: 14,
                  },
                  value: {
                    color: "#333",
                    fontSize: 24,
                    fontWeight: 700,
                    padding: [0, 0, 0, 10],
                  },
                  unit: {
                    color: "#333",
                    fontSize: 24,
                    fontWeight: 700,
                  },
                },
              },
              show: true,
            },
            data: lineYAxis,
          },
        ],
        xAxis: [
          {
            show: false,
          },
        ],
        series: pieSeries,
      };

      let myChart = this.$echarts.init(this.$refs.rongyu);
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
</style>
